/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {SegmentedButtonOptionModel} from './segmented-button-option.model';
import {SegmentedButtonDisplayModeEnum} from './segmented-button-display-mode.enum';

@Component({
    selector: 'app-segmented-button',
    templateUrl: './segmented-button.component.html',
    styleUrls: ['./segmented-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SegmentedButtonComponent<T> implements OnInit {

    @Input() options: SegmentedButtonOptionModel<T>[] = [];
    @Output() selectedOption: EventEmitter<T> = new EventEmitter<T>();

    private defaultSelectedButtons: boolean[] = [];

    ngOnInit(): void {
        this.options.map((element) => this.defaultSelectedButtons.push(element.isSelected));
    }

    getOptionClass(option: SegmentedButtonOptionModel<T>): string {
        let optionClass = `segmented-button-option ${option.displayMode}`;

        if (option.isSelected) {
            optionClass += ' selected';
        }

        return optionClass;
    }

    selectOption(option: SegmentedButtonOptionModel<T>): void {
        if (!option.isSelected) {
            this.options.map(item => item.label === option.label ? item.isSelected = true : item.isSelected = false);
            this.selectedOption.emit(option.value);
        }
    }

    buttonDataCy(option: SegmentedButtonOptionModel<T>): string {
        return `segmented-button-option-${option.value}`;
    }

    resetSelectedButtons(): void {
        this.options.map((element, index) => element.isSelected = this.defaultSelectedButtons?.[index]);
    }
}

